
class PasswordToggle {
    constructor() {
        this.toggleButtons = document.querySelectorAll(".toggle-password");
        this.passwordInputs = document.querySelectorAll(".user-password");

        this.toggleButtons.forEach(button => {
            button.addEventListener("click", this.toggle.bind(this, button));
        });
    }

    toggle(button) {
        const passwordInput = button.previousElementSibling;
        const type = passwordInput.getAttribute("type") === "password" ? "text" : "password";
        passwordInput.setAttribute("type", type);

        button.classList.toggle("icon-eye-blind");
    }
}

// Create an instance of the PasswordToggle class
const passwordToggle = new PasswordToggle();